export enum EntityStoreKey {
  roles = 'roles',
  ability = 'abilities',
}

export interface Position {
  id: number;
  position: number;
}

export type RolePosition = Position;
